/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaboratoryReport } from '../../models/laboratory-report';

export interface FindLaboratoryReports$Params {

/**
 * UUID of an animal
 */
  animalId: string;

/**
 * Maximum number of reports
 */
  count?: number;
}

export function findLaboratoryReports(http: HttpClient, rootUrl: string, params: FindLaboratoryReports$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LaboratoryReport>>> {
  const rb = new RequestBuilder(rootUrl, findLaboratoryReports.PATH, 'get');
  if (params) {
    rb.query('animalId', params.animalId, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LaboratoryReport>>;
    })
  );
}

findLaboratoryReports.PATH = '/api/lab-reports';
